import './LoginWeb3.css';
import { useWalletModal } from '@solana/wallet-adapter-react-ui';
import './LoginWeb3.css';
import { Button, Modal, Switch } from '../../ui';
import { useDevice, useLoginWeb3 } from '../../../hooks';
import { Link } from 'react-router-dom';

export function LoginWeb3(props: { title?: string; header?: boolean }) {
   const modalWallet = useWalletModal();
   const {
      ledgerExpanded,
      setLedgerExpanded,
      isLedger,
      setIsLedger,
      authenticateUser,
      disconnectWallet,
      isAuthenticated,
      wallet,
      setAuthRequested,
      showWalletConfirmModal,
      loading,
   } = useLoginWeb3();
   const { isMobile } = useDevice();

   return (
      <div className={`flex flex-col justify-between h-100 ${props.header ? 'items-center' : ''} gap-3 `}>
         {props.header && (
            <div className="flex items-center gap-2">
               {/* <img
                  src="/assets/icons/wallet-icon.svg"
                  alt=""
                  width={25}
               /> */}
               <h3>Connect wallet</h3>
            </div>
         )}

         {props.header && (
            <div className="wallet-img-container">
               <img
                  src="/assets/icons/wallet-connect-icon.svg"
                  alt="wallet"
               />
            </div>
         )}

         {!showWalletConfirmModal ? (
            <Button
               title={props.title || 'Select Wallet'}
               type="white-big"
               onClick={() => {
                  modalWallet.setVisible(true);
                  setAuthRequested(true);
               }}
            />
         ) : (
            <Modal
               className="auth-provider"
               onClose={disconnectWallet}
               active={isAuthenticated != undefined && wallet?.publicKey?.toString() !== undefined}
               darkBackground>
               <div className="flex items-center flex-col mb-1 gap-3">
                  <img
                     src="/assets/images/golfn-logo.png"
                     alt="logo"
                     width={isMobile ? 80 : 100}
                  />
                  <h4>Confirm Wallet</h4>
               </div>

               <div className="flex flex-col gap-2">
                  <div className="flex flex-col gap-1">
                     <div className="wallet-adr-container">
                        <p>{wallet?.publicKey?.toString().substring(0, 10) + '...' + wallet?.publicKey?.toString().substring(wallet?.publicKey?.toString().length - 10)}</p>
                     </div>
                     <p>* Please note that no amount will be charged by confirming.</p>
                     <p>
                        * By confirming, you agree to the{' '}
                        <Link
                           to={'/terms-and-conditions'}
                           target="_blank">
                           Terms of Service
                        </Link>
                     </p>
                  </div>

                  <div className={`ledger-accordion ${ledgerExpanded ? 'open' : ''}`}>
                     <div className="flex gap-small justify-end items-center ledger-accordion-header">
                        <img
                           src={'/assets/icons/arrow-back.svg'}
                           alt=""
                        />
                        <span onClick={() => setLedgerExpanded(!ledgerExpanded)}>Using a Ledger?</span>
                     </div>
                     <div className="ledger-accordion-content flex gap items-center">
                        <Switch
                           checked={isLedger}
                           onChange={setIsLedger}
                        />
                        <p>I'm using a Ledger</p>
                     </div>
                  </div>

                  <div className="flex flex-col gap-2">
                     <Button
                        title="Confirm wallet"
                        onClick={authenticateUser}
                        type="white-big"
                        disabled={loading}
                        loading={loading}
                     />
                     <div className="flex justify-center">
                        <Button
                           title="Cancel"
                           onClick={disconnectWallet}
                           type="transparent"
                           disabled={loading}
                        />
                     </div>
                  </div>
               </div>
            </Modal>
         )}
      </div>
   );
}
